import React from 'react'
import AuthContext from './AuthContext'
import { FEATURES, LOGIN_EXPERIENCE_TYPE } from 'config'
import { isFeatureEnabled, parseQuery } from 'utils'
import useSeatowService from './useSeatowService'
import useAuth0Service from './useAuth0Service'
import { useLocation } from 'react-router-dom'
import {
  getLoginExperience,
  setLoginExperience,
} from 'components/auth/authStorage'

const AuthProvider = ({ children }) => {
  const isCustomAuthEnabled = isFeatureEnabled(FEATURES.CUSTOM_LOGIN)
  const { search } = useLocation()
  const { loginExperience } = parseQuery(search)
  const storedLoginExperience = getLoginExperience()

  // Set login experience from query param if it exists. Otherwise, use
  // stored login experience or default to the new login experience.
  const currentLoginExperience =
    loginExperience?.toLowerCase() ||
    storedLoginExperience ||
    LOGIN_EXPERIENCE_TYPE.NEW

  setLoginExperience(currentLoginExperience)

  const isNewLogin = currentLoginExperience === LOGIN_EXPERIENCE_TYPE.NEW
  const shouldUseCustomAuth = isCustomAuthEnabled && isNewLogin

  /* eslint-disable react-hooks/rules-of-hooks */
  const authState = shouldUseCustomAuth ? useSeatowService() : useAuth0Service()

  const value = {
    ...authState,
    shouldUseCustomAuth,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthProvider
